export default "__VITE_ASSET__f3aaadff__"